import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";
import { Form } from "@shared/components";
import { useDateOptions } from "@shared/options";

export function BookMonthForm() {
  const translate = useTranslate();
  const { getMonthOptions, getYearOptions } = useDateOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="month"
          label={translate("v2/bookstore/book_month_admin.fields.month")}
          options={getMonthOptions().filter(o => o.value !== "")}
          required
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="year"
          label={translate("v2/bookstore/book_month_admin.fields.year")}
          options={getYearOptions().filter(o => o.value !== "")}
          required
        />
      </Grid>
    </Grid>
  );
}
